import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { reviewAssistedFlowInfo, reviewResultsSelector } from "../../../ReviewPage/redux/selector";
import { pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils"
import { LEAD_GEN_FORM } from "../../../../../shared/utils/util-constants";
import { submitQuerydetails } from "../../redux/thunks";

const AssistedForm = () => {
  const assistedFlowInfo = useSelector(reviewAssistedFlowInfo);
  const reviewData = useSelector(reviewResultsSelector);
  const [formState, setFormState] = useState({
    isSubmitted: false,
    hasError: false,
  });
  const [AssistantForm, setAssistantForm] = useState(null);

  useEffect(() => {
    import("@gommt-cabs/ui-lib").then((module) => {
      setAssistantForm(() => module.AssistantForm);
    });
  }, []);

  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const initialFormData = useMemo(() => ({
    from: reviewData?.source_city,
    to: reviewData?.destination_city,
  }), [reviewData]);

  const onFormSubmit = (data: any) => {
    try {
      const reqBody = {
        destination: data?.to?.val?.toUpperCase() || "",
        email: "",
        mobile: data?.mobileNumber?.val || "",
        name: data?.fullName?.val || "",
        passengers: 1,
        source: data?.from?.val?.toUpperCase() || "",
        travel_date:formatDate(data?.pickUpDate?.val) || "",
        page: "review",
        flavour:"cars_dweb"
      }
      const res = submitQuerydetails(reqBody);
      res
        .then((result) => {
          const isError = result?.error ? true : false;
          if (!isError) {
            setFormState({
              isSubmitted: true,
              hasError: false,
            });
          } else {
            setFormState({
              isSubmitted: true,
              hasError: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const trackEvent = (eventName: string) => {
    pushCtaOmniEvents(eventName, CTA_TYPE.HYPER_LINK, LEAD_GEN_FORM, window.location.href);
  };
  if (!AssistantForm) return <div>Loading...</div>;
  if(!assistedFlowInfo) return null;
  return (
    <AssistantForm
      initialFormData={initialFormData}
      formState={formState}
      setFormState={setFormState}
      onSubmit={onFormSubmit}
      trackEvent={trackEvent}
      autoOpenDelay={assistedFlowInfo?.auto_form_open_delay}
    />
  );
};

export default AssistedForm;